import { Box, Button, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import { logoutMenuItem } from "@/data/menu";
import { useAuthStore } from "@/contexts/useAuthStore";
import { sidebarTheme } from "@/styles/sidebarTheme";

interface SidebarLogoutButtonProps {
  onMenuItemClick?: () => void;
}

export const SidebarLogoutButton: React.FC<SidebarLogoutButtonProps> = ({
  onMenuItemClick,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { logout } = useAuthStore();
  const Icon = logoutMenuItem.icon;

  const handleLogout = () => {
    logout();
    if (onMenuItemClick && isMobile) onMenuItemClick();
  };

  return (
    <Box
      sx={{
        width: "100%",
        p: 2,
        borderTop: `1px solid ${sidebarTheme.border.logoutArea}`,
        background: sidebarTheme.background.logoutArea,
      }}
    >
      <Button
        onClick={handleLogout}
        fullWidth
        variant="outlined"
        startIcon={Icon && <Icon />}
        sx={{
          py: 1.5,
          px: 2,
          borderRadius: 1.5,
          borderColor: sidebarTheme.logout.border,
          color: sidebarTheme.logout.text,
          fontWeight: 500,
          fontSize: "0.95rem",
          textTransform: "none",

          "&:hover": {
            borderColor: sidebarTheme.logout.text,
            backgroundColor: sidebarTheme.logout.hoverBackground,
          },
        }}
      >
        {logoutMenuItem.text}
      </Button>
    </Box>
  );
};
